

















































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class TransactionFeeGaugeIcon extends Vue {
  @Prop({ type: String, default: '#52616b' }) readonly fill!: string;
  @Prop({ type: Number, default: 113.981 }) readonly height!: number;
}
